export const helperTabs = [
  { label: 'Related information', tabKey: 'information' },
  // { label: 'General information', tabKey: 'general-information' },
  // { label: 'Ask AI', tabKey: 'ask_ai' },
  // { label: 'Contact us', tabKey: 'contact_us' },
];
